/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Aircraft_CategoryInputs */

const en_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const es_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría`)
};

const fr_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie`)
};

const de_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

const ja_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`航空機のカテゴリ`)
};

const zh_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类别`)
};

const ar_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة`)
};

const id_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const it_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const ru_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория ВС`)
};

const pt_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const ko_field_aircraft_category = /** @type {(inputs: Field_Aircraft_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분류`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Field_Aircraft_CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_aircraft_category = /** @type {((inputs?: Field_Aircraft_CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Aircraft_CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_aircraft_category(inputs)
	if (locale === "es") return es_field_aircraft_category(inputs)
	if (locale === "fr") return fr_field_aircraft_category(inputs)
	if (locale === "de") return de_field_aircraft_category(inputs)
	if (locale === "ja") return ja_field_aircraft_category(inputs)
	if (locale === "zh") return zh_field_aircraft_category(inputs)
	if (locale === "ar") return ar_field_aircraft_category(inputs)
	if (locale === "id") return id_field_aircraft_category(inputs)
	if (locale === "it") return it_field_aircraft_category(inputs)
	if (locale === "ru") return ru_field_aircraft_category(inputs)
	if (locale === "pt") return pt_field_aircraft_category(inputs)
	return ko_field_aircraft_category(inputs)
});